// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header___g472","main-image":"Header_main-image__2Ci25","actions":"Header_actions__1gFyB","toggle":"Header_toggle__2EeNG","nav":"Header_nav__2RLVa"};